import axios from 'axios';

const instance = axios.create({
  baseURL: 'https://clarksonhonors.org:3001',
  withCredentials: true,
});

export default instance;
